import { RegionalMode, GameMode } from '../types';

export const CONTINENT_MODES: RegionalMode[] = ['africa', 'asia', 'europe', 'north-america', 'south-america'];
export const REGIONAL_MODES: RegionalMode[] = [...CONTINENT_MODES, 'india', 'china', 'asia-ex-india-china'];

export const GAME_MODES: GameMode[] = ['daily', 'random', 'top-100', 'local', 'pin', ...REGIONAL_MODES];

export const MODE_LABELS: Record<GameMode, string> = {
  daily: 'Daily challenge',
  random: 'Free play',
  'top-100': 'Top 100 run',
  local: 'Local run',
  pin: 'Pin run',
  africa: 'Africa run',
  asia: 'Asia run',
  europe: 'Europe run',
  'north-america': 'North America run',
  'south-america': 'South America run',
  india: 'India run',
  china: 'China run',
  'asia-ex-india-china': 'Asia (ex India/China)',
};

export function isRegionalMode(mode: GameMode): mode is RegionalMode {
  return REGIONAL_MODES.includes(mode as RegionalMode);
}
